import React,  {useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SlackSchedulerForm from './Form';
import { SG_ADD_SLACK_SCHEDULER, SG_GET_SLACK_BOT_SELECT } from "constants/actions";

const CreateSlackScheduler = () => {
  const dispatch = useDispatch();

  const handleSubmit = (formData) => {
    dispatch({ type: SG_ADD_SLACK_SCHEDULER, payload: formData });
  };

    useEffect(() => {
      dispatch({ type: SG_GET_SLACK_BOT_SELECT });
    }, [dispatch]);

  return (
    <div>
      <h1>Create Slack Scheduler</h1>
      <SlackSchedulerForm 
        onSubmit={handleSubmit} 
      />
    </div>
  );
};

export default CreateSlackScheduler;